import { SquaresFour } from "@phosphor-icons/react";
import { SectionShell } from "../../styleguide/Primitives";
import { Showcase } from "../LibraryPrimitives";
import {
  SubjectCard,
  ContinueCard,
  HomeworkCard,
  DailyChallengeCard,
  AchievementCard,
  LessonCard,
  TopicCard,
  EmptyStateCard,
} from "../cards";

export function CardsSection() {
  return (
    <SectionShell
      id="cards"
      eyebrow="Cards"
      eyebrowIcon={SquaresFour}
      title="Soft containers for everything"
      description="Cards are the workhorses of Bloom — rounded, gently shadowed and generously padded. They reflow from a single mobile column into multi-column grids on larger screens."
    >
      <div className="space-y-8">
        <Showcase title="Subject cards" description="Responsive grid · 1 → 4 columns" tone="muted">
          <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
            <SubjectCard subject="english" done={12} lessons={20} />
            <SubjectCard subject="maths" done={9} lessons={24} />
            <SubjectCard subject="reading" done={16} lessons={18} />
            <SubjectCard subject="science" done={4} lessons={15} />
          </div>
        </Showcase>

        <div className="grid gap-5 lg:grid-cols-2">
          <Showcase title="Continue learning"><ContinueCard /></Showcase>
          <Showcase title="Daily challenge"><DailyChallengeCard /></Showcase>
        </div>

        <Showcase title="Homework & lessons" tone="muted">
          <div className="grid gap-4 lg:grid-cols-2">
            <div className="space-y-3">
              <HomeworkCard subject="maths" title="Times tables: 6×" due="Tomorrow" />
              <HomeworkCard subject="english" title="Spelling list 4" due="Friday" />
            </div>
            <div className="space-y-3">
              <LessonCard subject="maths" title="Adding to 20" state="current" />
              <LessonCard subject="reading" title="Story sounds" state="done" />
              <LessonCard subject="science" title="Floating & sinking" state="locked" />
            </div>
          </div>
        </Showcase>

        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          <Showcase title="Achievement"><AchievementCard unlocked /></Showcase>
          <Showcase title="Locked"><AchievementCard unlocked={false} /></Showcase>
          <Showcase title="Topic">
            <div className="space-y-3">
              <TopicCard title="Fractions" subject="maths" count={8} />
              <TopicCard title="Phonics" subject="english" count={12} />
            </div>
          </Showcase>
          <Showcase title="Empty state"><EmptyStateCard /></Showcase>
        </div>
      </div>
    </SectionShell>
  );
}

export default CardsSection;
